<p-drawer
  [visible]="display"
  position="right"
  appendTo="body"
  (onHide)="onHide()">
  <div class="mb-2 left-sidebar clientdetails">
    <jni-order-line-ship-to
      #shipTo
      [parent]="form"
      [deliveryAddress]="deliveryAddress"
      [addressObject]="addressObject"
      [headerObject]="headerObject"
      [showAddress]="true"
      [formErrors]="formErrors"
      [clientShipToAddressDisabled]="false"
      [vendorNameShipToAddressDisabled]="false"
      [isEditFromCdi]="false"
      [fromAddressAssignment]="true"
      [defaultOneTime]="defaultOneTime"></jni-order-line-ship-to>

    <button
      class="btn btn-primary me-3 post"
      type="submit"
      (click)="onSubmit()">
      Save
    </button>
  </div>
</p-drawer>
